<template>
  <div class="page-ct">
    <div class="page" :class="layoutClass" v-loading="loading">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page',

  provide() {
    return {
      page: this
    }
  },

  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    layout: {
      type: String,
      required: false
    }
  },

  computed: {
    layoutClass() {
      if (this.layout) {
        return 'layout-' + this.layout
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
.page-ct {
  width: 100%;
  overflow: auto;
  background-color: #f2f5f9;
}

.page {
  flex: 1;
  height: 100%;
}

.page {
  background: #f2f5f9;
}

.page.layout-tabbed {
  background: #ffffff;
}

.page.layout-tabbed >>> .page {
  background: #ffffff !important;
}

.page.layout-tabbed .header {
  border-bottom: 0 none;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/Page.vue